import { NamePath } from 'antd/es/form/interface';
import FormSelect from 'components/form/FormSelect';
import { InfinitySelectProps } from 'components/form/InfinitySelect';

interface IPaymentTypeFilterProps {
  name?: NamePath;
  nameInRoot?: NamePath;
  reference?: InfinitySelectProps;
}

const VALIDATE_RULES = [{ required: true, message: 'Missing value' }];

export default function PaymentTypeFilter({
  name,
  nameInRoot,
  reference,
}: IPaymentTypeFilterProps) {
  return (
    <FormSelect
      nameFormItem={name}
      name={nameInRoot}
      rules={VALIDATE_RULES}
      reference={reference}
      placeholder="No selection"
      className="min-w-[200px]"
    />
  );
}
